"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Darwin = void 0;
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const Resources_1 = require("../../Resources");
const Size_1 = require("../render/Size");
class Darwin extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.DARWIN,
            cardType: CardType_1.CardType.LEADER,
            metadata: {
                cardNumber: 'L39',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.greyPlate('Dominant party change').nbsp(Size_1.Size.SMALL).colon().megacredits(2);
                    b.br.br;
                    b.opgArrow().plus().influence(2).asterix();
                    b.br;
                }),
                description: 'Gain 2 M€ whenever the dominant party changes. Once per game, gain 2 influence for THIS GENERATION only.',
            },
        });
        this.isDisabled = false;
        this.opgActionIsActive = false;
    }
    play() {
        return undefined;
    }
    canAct() {
        return this.isDisabled === false;
    }
    action() {
        this.isDisabled = true;
        this.opgActionIsActive = true;
        return undefined;
    }
    static onDominantPartyChange(game) {
        game.getPlayers()
            .filter((player) => player.cardIsInEffect(CardName_1.CardName.DARWIN))
            .forEach((player) => player.addResource(Resources_1.Resources.MEGACREDITS, 2, { log: true }));
    }
}
exports.Darwin = Darwin;
//# sourceMappingURL=Darwin.js.map